export default function LoadingComponent() {
	return (
		<div className="loader-main">
			<img src="/chip.png" className="loader-main_icon" alt="preloader" />
		</div>
	);
}
